jQuery(document).ready(function ($) {
    /*
     * Общие настройки ajax-запросов, отправка на сервер csrf-токена
     */
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('#csrf_token').val()
        }
    });

    let page_url = $('#page_url').val();
    const base_url = $('#base_url').val();
    const category_path = $('#category_path').val();

    $('#filter').on('click', () => {
        const brand_selected = $('#brands').val();
        const manufacturer_selected = $('#manufacturers').val();
        const {url} = url_separation();
        const facet = {
            brand: brand_selected === 'all' ? '' : '/br_' + brand_selected,
            manufacturer: manufacturer_selected === 'all' ? '' : '/pr_' + manufacturer_selected,
        }
        window.location.href = url + facet.brand + facet.manufacturer;
    });

    function url_separation() {
        if (!page_url.length) return {url: null}
        let url = page_url;
        if (url.indexOf('/br_') !== -1) {
            url = url.slice(0, url.indexOf('/br_'));
        }
        if (url.indexOf('/pr_') !== -1) {
            url = url.slice(0, url.indexOf('/pr_'));
        }
        return {url}
    }

    $('#filter_brand .open').on('click', () => {
        $('#filter_brand .choice').fadeToggle(200);
    });

    $('#filter_manufacturer .open').on('click', () => {
        $('#filter_manufacturer .choice').fadeToggle(200);
    });

    // $(document).on('click', (e) => {
    //     if ($(e.target).closest('#filter_brand').length === 0) {
    //         $('#filter_brand .choice').fadeOut(200);
    //     }
    //     if ($(e.target).closest('#filter_manufacturer').length === 0) {
    //         $('#filter_manufacturer .choice').fadeOut(200);
    //     }
    // });

    $('#filter_brand .reset').on('click', () => {
        $('#filter_brand .choice').fadeOut(200);
    });

    $('#filter_manufacturer .reset').on('click', () => {
        $('#filter_manufacturer .choice').fadeOut(200);
    });

    $('.show-filter').hover((e) => {
        const filter = collect_filter();
        $(e.target).closest('a').prop('href', category_path + filter);
    }, () => 0);

    $('.categories_block a').hover((e) => {
        link_filter(e);
    });

    function link_filter(e)
    {
        const filter = collect_filter();
        if ($(e.currentTarget).data('withoutfilter') == true)
            $(e.currentTarget).prop('href', $(e.currentTarget).data('url'));
        else
            $(e.currentTarget).prop('href', $(e.currentTarget).data('url') + filter);
    }

    function collect_filter() {
        let path = '';
        let brands = [], manufacturers = [];
        $('.brands').each(function (index, el) {
            if ($(el).prop('checked') === true) brands.push($(el).data('slug'));
        });
        $('.manufacturers').each(function (index, el) {
            if ($(el).prop('checked') === true) manufacturers.push($(el).data('slug'));
        });
        if (brands.length < 2 && manufacturers.length < 2) {
            if (brands[0]) path += `/br_${brands[0]}`;
            if (manufacturers[0]) path += `/pr_${manufacturers[0]}`;
            return path;
        } else {
            if (brands.length) {
                if (!path.length) {
                    path = '?brand=' + brands.join('|');
                } else {
                    path += '&brand=' + brands.join('|');
                }
            }
            if (manufacturers.length) {
                if (!path.length) {
                    path = '?manufacturer=' + manufacturers.join('|');
                } else {
                    path += '&manufacturer=' + manufacturers.join('|');
                }
            }
            return path;
        }
    }
});
